import { combineReducers } from 'redux'
import userReducer from './userReducer'
import promoReducer from './promoReducer'
import driverReducer from './driverReducer'
import orderReducer from './orderReducer'
import stockReducer from './stockReducer'
import productReducer from './productReducer'
import financesReducer from './financesReducer'
import supportReducer from './supportReducer'
import pushNotificationReducer from './pushNotificationReducer'
import categoriesReducer from './categoriesReducer'
import firebaseRealTimeReducer from './firebaseRealTimeReducer'
import modalReducer from './modalReducer'
import componentReducer from './componentReducer'
import pagesReducer from './pagesReducer'
import sidebarReducer from './sidebarReducer'

const allReducers = combineReducers({
  componentReducer,
  user: userReducer,
  promos: promoReducer,
  drivers: driverReducer,
  orders: orderReducer,
  stock: stockReducer,
  products: productReducer,
  finances: financesReducer,
  support: supportReducer,
  notifs: pushNotificationReducer,
  categories: categoriesReducer,
  firebaseRealTime: firebaseRealTimeReducer,
  modals: modalReducer,
  page: pagesReducer,
  sidebar: sidebarReducer
});

export default allReducers;
